<div class="comm">

    <div class="comm-table-wrap" *ngIf="correspondence && correspondence.length > 0">
        <table class="comm-table">
            <thead>
                <tr>
                    <th class="th-date" (click)="orderCorrespondence(true)">
                        <span>Fecha inserción</span>
                        <span class="sort-arrow"
                              [class.sort-arrow--asc]="orderDesc"
                              [class.sort-arrow--desc]="!orderDesc"
                              aria-hidden="true"></span>
                    </th>
                    <th>Comunicación</th>
                    <th>Formato</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let cor of correspondence">
                    <td>
                        <a class="comm-link" (click)="onGetEventFile(cor)">{{ cor.creationDate | date: 'dd/MM/yyyy' }}</a>
                    </td>
                    <td>
                        <a class="comm-link" (click)="onGetEventFile(cor)">{{ cor.name }}</a>
                    </td>
                    <td>
                        <a class="comm-link" (click)="onGetEventFile(cor)">{{ cor.format }}</a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="comm-empty" *ngIf="!correspondence || correspondence.length === 0">
        <p>No hay comunicaciones en este expediente.</p>
    </div>

</div>
